// Drives the disc's white → colour bloom. Returns 0..1. The value jumps to 1
// with no animation when the page mounts already graded (a reload mid-demo
// must not replay the reveal), and animates 0 → 1 the moment `active` flips
// to true while mounted — i.e. when the first student's grades land.
import { useEffect, useRef, useState } from 'react'

const BLOOM_MS = 2200

export function useBloom(active: boolean): number {
  const [progress, setProgress] = useState(active ? 1 : 0)
  const prev = useRef(active)
  useEffect(() => {
    const wasActive = prev.current
    prev.current = active
    if (!active) {
      setProgress(0)
      return undefined
    }
    if (wasActive) return undefined
    const reduce = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    if (reduce) {
      setProgress(1)
      return undefined
    }
    let frame = 0
    const start = performance.now()
    const step = (now: number) => {
      const t = Math.min(1, (now - start) / BLOOM_MS)
      setProgress(t)
      if (t < 1) frame = requestAnimationFrame(step)
    }
    frame = requestAnimationFrame(step)
    return () => cancelAnimationFrame(frame)
  }, [active])
  return progress
}
